import {HttpClient, HttpEventType} from '@angular/common/http';
import {Injectable}                from '@angular/core';
import {Subscription}              from 'rxjs';
import {finalize}                  from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FileService
{
    public files: File[] = [];

    public uploadProgress: number = null;

    public uploadSubscription: Subscription;

    constructor(
        private http: HttpClient
    )
    {
    }

    public upload(url: string, fieldName: string): void
    {
        const formData = new FormData();

        for (let i = 0; i < this.files.length; i++) {
            formData.append(`${fieldName}`, this.files[i]);
        }

        const upload$ = this.http.post(`${url}`, formData, {
            reportProgress: true,
            observe: 'events'
        }).pipe(
            finalize(() => this.reset())
        );

        this.uploadSubscription = upload$.subscribe(event => {
            if (event.type === HttpEventType.UploadProgress) {
                this.uploadProgress = Math.round(100 * (event.loaded / event.total));
            }
        });
    }

    public append(controlName: string, formData: FormData, multiple: boolean = false): void
    {
        for (let i = 0; i < this.files.length; i++) {
            const fieldName = multiple
                ? `${controlName}[]`
                :  `${controlName}`;

            formData.append(`${fieldName}`, this.files[i]);
        }
    }

    public cancelUpload(): void
    {
        this.uploadSubscription.unsubscribe();
        this.reset();
    }

    public reset(): void
    {
        this.uploadProgress = null;
        this.uploadSubscription = null;
        this.files = null;
    }
}